import styled from "styled-components";
import { devices } from "@/constants/media";

export const StyledCompatibilityWarning = styled.div<{
  $height: number;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${({ $height }) => $height}px;
  background-color: var(--color-background);
`;

export const StyledCompatibilityList = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-md);
  padding: 0;
  li {
    white-space: nowrap;
    text-align: center;
    a {
      color: var(--color-text);
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--spacing-sm);
    }
    img {
      width: 50px;
      height: 50px;
      object-fit: contain;
      margin: 0;
    }
  }
  @media ${devices.xs} {
    flex-wrap: wrap;
    li {
      flex: 0 0 calc(50% - var(--spacing-md));
      min-width: calc(50% - var(--spacing-md));
    }
  }
`;
